const config = {
    build_number: '615905',
    build_timestamp: '2026-09-09T14:46:36.122Z',
    build_commit: '8d8efb776ee550fba54a6193d5e567dc2685f802',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
